import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { RaceSliderHr } from 'src/domains/sportsbook/webview/components/racesSlider/horseRacing/RaceSliderHr';
import { RaceSliderGr } from 'src/domains/sportsbook/webview/components/racesSlider/greyhoundRacing/RaceSliderGr';
import { sortGreyhoundsSelections, sortSelections } from 'src/domains/layouts/utils/sortSelections';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

export interface RaceSliderItemPropsType {
    eventId: EventId;
}

export const RaceSliderItem = observer('RaceSlider', (props: RaceSliderItemPropsType) => {
    const { eventId } = props;

    const eventModel = eventId.getEventModel();
    if (eventModel === null) {
        return null;
    }

    const marketModel = eventModel.marketRaceWinner[0];
    if (marketModel === undefined) {
        return null;
    }

    if (marketModel.trapChallengeTag === 'yes') {
        return null;
    }

    if (eventModel.sport === 'horseracing') {
        return (
            <RaceSliderHr
                race={eventModel}
                market={marketModel}
                sortSelections={sortSelections}
            />
        );
    }

    return (
        <RaceSliderGr
            race={eventModel}
            market={marketModel}
            sortSelections={sortGreyhoundsSelections}
        />
    );
});
